import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/private/MessageStatusLoader.module_built.css";
const classes = {"message-status-loader":"wgymfeG_message-status-loader"}
export default classes

const _message_status_loader0 = classes["message-status-loader"]
export { _message_status_loader0 as "message-status-loader" }
